import universalTracker from './universal'
import ga4Tracker from './ga4'

export default function(config) {
    switch (config.version) {
        case 'universal':
            return universalTracker
        case 'ga4':
            return ga4Tracker
        default:
            return
    }
}
